import moment from 'moment';

angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.ComplianceRuleConditionsService', MxComplianceRuleConditionsService);
MxComplianceRuleConditionsService.$inject = [
	'$q',
	'mx.SolutionBuilderAgent.ConditionsBuilder.Builder',
	'mx.SolutionBuilderAgent.ConditionsBuilder.Enums',
	'mx.SolutionBuilderAgent.ConditionsBuilder.Helper',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.SolutionBuilderAgent.SchemaService',
	'mx.SolutionBuilderAgent.SchemaService.Enums',
	'mx.SolutionBuilderAgent.ComplianceRuleEnums',
];

function MxComplianceRuleConditionsService($q, ConditionsBuilder, ConditionsBuilderEnums, helper, entityService, schemaService, SchemaServiceEnums, ComplianceRuleEnums) {
	var ComplianceRuleTriggerTypes = ComplianceRuleEnums.ComplianceRuleTriggerTypes;
	var ComplianceRuleConditionStart = ComplianceRuleEnums.ComplianceRuleConditionStart;
	var ConditionValueTypes = ConditionsBuilderEnums.ConditionValueTypes;
	var ConditionTypes = ConditionsBuilderEnums.ConditionTypes;
	var ConditionBuilderMode = ConditionsBuilderEnums.ConditionBuilderMode;
	var DataTypes = SchemaServiceEnums.DataTypes;
	var RelatedClassCardinality = SchemaServiceEnums.RelatedClassCardinality;

	var self = this;
	var cache = {
		properties: {},
	};
	var pickerPromise, operatorsPromise;

	self.getBuilder = getBuilder;
	self.getProperties = getProperties;

	var MxComplianceRuleEnumerationMap = {
		get startCondition() {
			var startConditionMap = {};
			startConditionMap[ComplianceRuleTriggerTypes.CreateObject] = [ComplianceRuleConditionStart.After];
			startConditionMap[ComplianceRuleTriggerTypes.DeleteObject] = [ComplianceRuleConditionStart.Before];
			startConditionMap[ComplianceRuleTriggerTypes.ChangeObject] = [ComplianceRuleConditionStart.Before, ComplianceRuleConditionStart.After];

			return startConditionMap;
		},

		filter: function (fieldName, sourceKey, enumeration) {
			if (!Array.isArray(enumeration)) {
				return [];
			}

			var map = this[fieldName];

			if (!map) {
				return enumeration;
			}

			if (!(sourceKey in map)) {
				return enumeration;
			}

			var sourceMap = map[sourceKey];

			return enumeration.filter(function (enumValue) {
				return sourceMap.some(function (sourceMapValue) {
					return sourceMapValue === enumValue.value;
				});
			});
		},
	};

	return self;

	function getBuilder({ trigger, conditions, typeIds, isBasedOnDD = false }) {
		var config = {};

		var isObjectTrigger =
			trigger === ComplianceRuleTriggerTypes.CreateObject ||
			trigger === ComplianceRuleTriggerTypes.DeleteObject ||
			trigger === ComplianceRuleTriggerTypes.ChangeObject ||
			trigger === ComplianceRuleTriggerTypes.Action;

		if (!isObjectTrigger) {
			return $q.when();
		}

		pickerPromise = pickerPromise || loadPickers();

		return pickerPromise
			.then(function (pickersConfig) {
				config = angular.copy(pickersConfig);
				config.startConditions.enumeration = MxComplianceRuleEnumerationMap.filter('startCondition', trigger, config.startConditions.enumeration);
				config.conditionOutput = conditionOutput;
				config.groupOutput = groupOutput;
				config.builderOutput = builderOutput;
				config.trigger = trigger;
				config.maxLevel = 1;
				return getOperators(trigger);
			})
			.then(function (operators) {
				config.operators = operators;
				config.mode = ConditionBuilderMode.disableDifferentOperatorsInGroup;

				if (Array.isArray(conditions)) {
					config.predefinedConditions = {
						Conditions: [],
						Groups: [],
					};
					var groups = {};

					var promises = conditions
						.sort(function (conditionA, conditionB) {
							return (Number(conditionA.Order) || 0) - (Number(conditionB.Order) || 0);
						})
						.map(function (condition) {
							return conditionInputMapping({ condition: condition, typeIds: typeIds, isBasedOnDD: isBasedOnDD });
						});

					return $q.all(promises).then(function (mappedConditions) {
						conditions.forEach(function (condition, index) {
							var mappedCondition = mappedConditions[index];
							if (!mappedCondition) {
								return;
							}

							if (!condition.Group) {
								config.predefinedConditions.Conditions.push(mappedCondition);
								// config.LogicOperator = Number(condition.ClauseCondition);
								return;
							}
							if (groups[condition.Group]) {
								groups[condition.Group].Conditions.push(mappedCondition);
							} else {
								groups[condition.Group] = {
									Conditions: [mappedCondition],
									LogicOperator: mappedCondition.LogicOperator,
									Order: index,
								};
							}
						});

						Object.keys(groups)
							.sort(function (keyA, keyB) {
								return Number(keyB) - Number(keyA);
							})
							.forEach(function (key) {
								config.predefinedConditions.Groups.push(groups[key]);

								if (hasDifferentLogicOperators(groups[key].Conditions.slice(1))) {
									config.mode = ConditionBuilderMode.enableDifferentOperatorsInGroup;
								}
							});

						var children = config.predefinedConditions.Conditions.concat(config.predefinedConditions.Groups).sort(function (childA, childB) {
							return (Number(childA.Order) || 0) - (Number(childB.Order) || 0);
						});
						if (hasDifferentLogicOperators(children.slice(1))) {
							config.mode = ConditionBuilderMode.enableDifferentOperatorsInGroup;
						}

						return config;
					});
				}
			})
			.then(function () {
				return new ConditionsBuilder(config);
			});
	}

	function hasDifferentLogicOperators(conditions) {
		if (conditions.length > 1) {
			var operator = conditions[0].LogicOperator;
			return conditions.some(function (condition) {
				return condition.LogicOperator !== operator;
			});
		}
		return false;
	}

	function getValueOfInputCondition({ condition, typeIds, isBasedOnDD = false }) {
		if (condition.ValueType === ConditionValueTypes.Value) {
			return $q.when(condition.Value);
		} else if (condition.ValueType === ConditionValueTypes.Attribute) {
			if (typeof condition.ValueExpression === 'string' && condition.ValueExpression.indexOf('.')) {
				var className = condition.ValueExpression.substring(condition.ValueExpression.indexOf('(') + 1, condition.ValueExpression.indexOf(')'));
				return getClassPropertyByName({
					className: className,
					attributeName: condition.ValueExpression.split('.')[1],
					typeIds: typeIds,
					isBasedOnDD: isBasedOnDD,
				}).then(function (property) {
					return property.AttributeId;
				});
			}
		} else if (condition.ValueType === ConditionValueTypes.Expression) {
			return $q.when(condition.ValueExpression);
		}
	}

	function conditionInputMapping({ condition, typeIds, isBasedOnDD = false }) {
		var classId;
		if (typeof condition.AttributePath === 'string' && condition.AttributePath.indexOf('.') >= 0) {
			classId = condition.AttributePath.split('.')[0].toLowerCase();
		} else if (condition.AttributePath) {
			classId = condition.AttributePath.toLowerCase();
		}

		return schemaService
			.getClass(classId, true)
			.then(function (classObj) {
				return getClassPropertyById({ className: classObj.InternalName, attributeId: condition.AttributeId, typeIds: typeIds, isBasedOnDD: isBasedOnDD });
			})
			.then(function (property) {
				if (!property) {
					return $q.when(property);
				}

				property.Id = condition.Id;
				property.ValueType = Number(condition.ValueType);
				property.ConditionStart = Number(condition.ConditionStart) || ComplianceRuleConditionStart.After;
				property.Operator = Number(condition.Operator);
				property.LogicOperator = Number(condition.ClauseCondition);
				property.Order = Number(condition.Order);

				return getValueOfInputCondition({ condition: condition, typeIds: typeIds, isBasedOnDD: isBasedOnDD }).then(function (value) {
					// for BoolType
					if (property.TypeId === 9 && (!property.IsAttribute || property.ValueType === 0)) {
						if (typeof value === 'string') {
							// to convert '0' to false and '1' to true
							value = parseInt(value);
						}
						value = Boolean(value);
					}

					if (property.TypeId === 3 && (!property.IsAttribute || property.ValueType === 0)) {
						// CoRU "Date" format = 4/10/2024 1:44:00 PM
						// CoRU "DateExpression" format = Today + 1
						// moment(Today + 1).isValid() === true, so it is necessary to check -/+ additionally
						const inputDate = moment(value);
						const isDateMode = inputDate.isValid() && typeof value === 'string' && !value.includes('Today') && !value.includes('+') && !value.includes('-');
						value = isDateMode ? inputDate.toISOString() : value;
					}

					property.Value = value;
					return property;
				});
			});
	}

	function builderOutput(builder) {
		var conditions = builder.conditions.map(function (condition) {
			condition.output.Order = builder.conditions.indexOf(condition);
			return condition.output;
		});
		var order = conditions.length;
		var groupsConditions = builder.groups.map(function (group) {
			if (Array.isArray(group.output)) {
				group.output.forEach(function (condition) {
					condition.Group = builder.groups.indexOf(group) + 1;
					condition.Order = order;
					order++;
				});
			}
			return group.output;
		});

		return Array.prototype.concat.apply(conditions, groupsConditions);
	}

	function groupOutput(group) {
		return group.conditions.map(function (condition, index) {
			condition.output.Order = index;
			if (index === 0) {
				condition.output.ClauseCondition = group.logicOperatorValue;
			}
			return condition.output;
		});
	}

	function conditionOutput(condition) {
		var value = null,
			valueExpression = null;
		var selectedAttributeId;

		if (condition.type !== ConditionTypes.Fragment && condition.type !== ConditionTypes.MultiFragment) {
			if (condition.valueTypeValue === ConditionValueTypes.Value) {
				value = condition.value;
			} else if (condition.valueTypeValue === ConditionValueTypes.Attribute && condition.selectedAttribute) {
				var attributePath = condition.selectedAttribute.AttributeClassPath;
				var attributeName = attributePath.substr(attributePath.lastIndexOf('.') + 1);
				valueExpression = 'T(' + condition.selectedAttribute.EntityClassName + ').' + attributeName;
				selectedAttributeId = condition.selectedAttribute.AttributeId;
				value = selectedAttributeId;
			} else if (condition.valueTypeValue === ConditionValueTypes.Expression) {
				valueExpression = condition.value;
			}
		}

		if (condition._options.TypeId === 9 && !selectedAttributeId) {
			value = value ? '1' : '0';
		}

		return {
			ID: condition.id,
			// Order: condition.parent.conditions.indexOf(condition),
			ValueType: condition.valueTypeValue,
			Value: value,
			ValueExpression: valueExpression,
			AttributePath: condition._options.AttributePath,
			ConditionStart: condition.startConditionValue,
			AttributeId: condition._options.AttributeId,
			Operator: condition.operatorValue,
			ClauseCondition: condition.logicOperatorValue,

			/* extra properties to avoid extra requests in wizard */
			ReferenceTo: condition._options.ReferenceTo,
			ReferenceFilter: condition._options.ReferenceFilter,
			TypeId: condition._options.TypeId,
			ConditionType: condition.conditionType,
			SelectedAttributeId: selectedAttributeId,
			Name: condition.name,
			EntityClassName: condition._options.EntityClassName,
		};
	}

	function loadPickers() {
		var pickers = {
			logicOperators: {
				enumClassName: 'SPSComplianceRulePickupClauseCondition',
			},
			valueTypes: {
				enumClassName: 'SPSComplianceRulePickupConditionValueType',
			},
			startConditions: {
				enumClassName: 'SPSComplianceRulePickupConditionStart',
			},
		};
		var promises = [];
		var keys = Object.keys(pickers);
		keys.forEach(function (key) {
			promises.push(
				entityService.getEnumeration(pickers[key].enumClassName).then(function (enumeration) {
					pickers[key].enumeration = enumeration.Values.map(function (value) {
						return {
							title: value.DisplayString,
							value: value.Value,
						};
					});
				})
			);
		});

		return $q.all(promises).then(function () {
			return pickers;
		});
	}

	function getOperators(trigger) {
		operatorsPromise = operatorsPromise || loadOperators();
		return operatorsPromise.then(function (operatorsByTrigger) {
			if (!operatorsByTrigger) {
				return null;
			}

			return operatorsByTrigger[trigger];
		});
	}

	function loadOperators() {
		return schemaService.getClassInfo('SPSComplianceRulePickupOperators').then(function (classInfo) {
			if (!classInfo || !Array.isArray(classInfo.Data)) {
				return $q.when(null);
			}

			var operatorsByType = {};
			var conditionTypeIds = [];
			Object.keys(ConditionTypes).forEach(function (key) {
				var id = ConditionTypes[key];
				conditionTypeIds.push(id);
				operatorsByType[id] = [];
			});

			classInfo.Data.sort(function (itemA, itemB) {
				return Number(itemA.Value) - Number(itemB.Value);
			}).forEach(function (item) {
				var operator = {
					title: item.DisplayString,
					value: item.Value,
					supportedTriggers: item.SupportedTriggers,
					unconfigurableStartCondition: item.Value >= 12, // //Fragment/Relation Changed/Added/Removed
					unconfigurableValue:
						item.Value >= 12 || //Fragment/Relation Changed/Added/Removed
						item.Value === 6 || //IsEmpty
						item.Value === 7, //IsNotEmpty
				};

				if (typeof item.SupportedTypes === 'string') {
					item.SupportedTypes.split(',').forEach(function (type) {
						type = Number(type);
						if (!Array.isArray(operatorsByType[type])) {
							operatorsByType[type] = [];
						}
						operatorsByType[type].push(operator);
					});
				} else {
					conditionTypeIds.forEach(function (id) {
						operatorsByType[id].push(operator);
					});
				}
			});

			var operatorsByTrigger = {};

			Object.keys(ComplianceRuleTriggerTypes).forEach(function (key) {
				var triggerId = ComplianceRuleTriggerTypes[key];
				operatorsByTrigger[triggerId] = {};
				conditionTypeIds.forEach(function (conditionId) {
					operatorsByTrigger[triggerId][conditionId] = operatorsByType[conditionId].filter(function (operator) {
						if (typeof operator.supportedTriggers === 'string') {
							return operator.supportedTriggers.split(',').indexOf(triggerId.toString()) >= 0;
						}
						return true;
					});
				});
			});

			return operatorsByTrigger;
		});
	}

	function loadStatusPickup(condition, className, typeIds) {
		return entityService.getEnumerationValues(condition._options.ReferenceTo, condition._options.ReferenceFilter).then(function (enumeration) {
			return getStateGroups(className, typeIds).then(function (stateGroups) {
				return Array.prototype.concat.apply(
					[],
					stateGroups.map(function (stateGroup) {
						return enumeration
							.filter(function (enumItem) {
								return stateGroup.value === enumItem.StateGroup;
							})
							.map(function (enumItem) {
								return {
									title: enumItem.DisplayString + (stateGroups.length > 1 ? ' (' + stateGroup.title + ')' : ''),
									value: enumItem.Value,
								};
							})
							.sort(function (a, b) {
								return ('' + a.title).localeCompare(b.title);
							});
					})
				);
			});
		});
	}

	function enumLoader(condition, className, typeIds) {
		if (condition._options.ReferenceTo === 'SPSCommonPickupObjectStatus') {
			return loadStatusPickup(condition, className, typeIds);
		}

		return entityService.getEnumerationValues(condition._options.ReferenceTo, condition._options.ReferenceFilter).then(function (enumeration) {
			return enumeration
				.map(function (item) {
					return {
						title: item.DisplayString,
						value: item.Value,
					};
				})
				.sort(function (a, b) {
					return ('' + a.title).localeCompare(b.title);
				});
		});
	}

	function getClassPropertyByName({ className, attributeName, typeIds, isBasedOnDD = false }) {
		return getClassConditionInfo({ className: className, typeIds: typeIds }).then(function (classConditionInfo) {
			return getClassProperties({ classObject: classConditionInfo, typeIds: typeIds, isBasedOnDD: isBasedOnDD }).then(function (properties) {
				return angular.copy(
					properties.filter(function (property) {
						if (property.IsAttribute) {
							var attributeClassPath = className + '.' + attributeName;
							return property.AttributeClassPath === attributeClassPath;
						}
					})[0]
				);
			});
		});
	}

	function getClassPropertyById({ className, attributeId, typeIds, isBasedOnDD = false }) {
		return getClassConditionInfo({ className: className, typeIds: typeIds }).then(function (classConditionInfo) {
			return getClassProperties({ classObject: classConditionInfo, trigger: ComplianceRuleTriggerTypes.ChangeObject, typeIds: typeIds, isBasedOnDD: isBasedOnDD }).then(
				function (properties) {
					return angular.copy(
						properties.filter(function (property) {
							return property.AttributeId === attributeId;
						})[0]
					);
				}
			);
		});
	}

	function getClassConditionInfo({ className, typeIds }) {
		return schemaService.getClassInfo(className).then(function (classInfo) {
			var usedTypeCardinalities = (classInfo.Cardinalities || []).filter(function (typeCardinality) {
				return typeIds.some(function (typeId) {
					return typeId === typeCardinality.TypeId;
				});
			});

			return {
				Name: classInfo.InternalName,
				Cardinality: usedTypeCardinalities.length > 0 ? usedTypeCardinalities[0].Cardinality : RelatedClassCardinality.one,
			};
		});
	}

	function getClassProperties({ classObject, trigger, typeIds, isBasedOnDD = false }) {
		cache.properties[classObject.Name] =
			cache.properties[classObject.Name] ||
			schemaService.getClassInfo(classObject.Name).then(function (classEntity) {
				var attributes = classEntity.Attributes || [];
				var relations = classEntity.Relations || [];

				var mappedAttributes = attributes.map(function (property) {
					var conditionType = getConditionType(property);

					var attrTitle = classEntity.DisplayName ? classEntity.DisplayName : classEntity.InternalName;
					attrTitle += '.' + property.InternalName;
					attrTitle += property.DisplayName ? ' (' + property.DisplayName + ')' : '';

					return {
						AttributeId: property.Id,
						AttributePath: classEntity.Id + '.' + property.InternalName,
						IsAttribute: true,
						Title: attrTitle,
						Name: property.InternalName,
						ConditionType: conditionType,
						ConditionStart: ComplianceRuleConditionStart.After,
						EnumLoader: undefined,
						EntityClassName: classEntity.InternalName,
						ReferenceTo: conditionType === ConditionTypes.EnumerationReference ? property.PickupClass.InternalName : undefined,
						ReferenceFilter: null,
						TypeId: property.Datatype || 0,
						TypeName: getDataTypeName(property),
						AttributeClassPath: classEntity.InternalName + '.' + property.InternalName,
						RelationType: undefined,
					};
				});

				var mappedRelations = relations.map(function (property) {
					var relationTitle = classEntity.DisplayName ? classEntity.DisplayName : classEntity.InternalName;
					relationTitle += '.' + property.AttributeLeft.InternalName;
					relationTitle += property.AttributeLeft.DisplayName ? ' (' + property.AttributeLeft.DisplayName + ')' : '';

					return {
						AttributeId: property.AttributeLeft.Id,
						AttributePath: classEntity.Id + '.' + property.AttributeLeft.InternalName,
						IsAttribute: true,
						Title: relationTitle,
						Name: property.AttributeLeft.InternalName,
						ConditionType: helper.getConditionTypeByRelation(property.RelationType),
						ConditionStart: ComplianceRuleConditionStart.After,
						EnumLoader: undefined,
						EntityClassName: classEntity.InternalName,
						ReferenceTo: property.ClassRight.InternalName,
						ReferenceFilter: null,
						TypeId: 1,
						TypeName: 'GuidType',
						AttributeClassPath: classEntity.InternalName + '.' + property.AttributeLeft.InternalName,
						RelationType: property.RelationType,
					};
				});

				mappedAttributes = mappedAttributes.concat(mappedRelations);

				return {
					DisplayName: classEntity.DisplayName,
					Name: classEntity.DisplayName,
					Id: classEntity.Id,
					UsedInTypes: classEntity.UsedInTypes,
					properties: mappedAttributes,
				};
			});

		return cache.properties[classObject.Name].then(function (classEntity) {
			var localEnumLoader = function (condition) {
				return enumLoader(condition, classObject.Name, typeIds);
			};

			if (!isBasedOnDD && (classObject.Cardinality === RelatedClassCardinality.oneOrMany || classObject.Cardinality === RelatedClassCardinality.zeroOrMany)) {
				return trigger === ComplianceRuleTriggerTypes.ChangeObject || trigger === ComplianceRuleTriggerTypes.CreateObject
					? [
							{
								AttributeId: classEntity.Id,
								AttributePath: classEntity.Id,
								Title: classEntity.DisplayName,
								Name: classEntity.Name,
								EntityClassName: classObject.Name,
								ConditionType: ConditionTypes.MultiFragment,
							},
					  ]
					: [];
			} else {
				var properties = classEntity.properties.slice();
				properties.forEach(function (property) {
					if (property.ConditionType === ConditionTypes.EnumerationReference) {
						property.EnumLoader = localEnumLoader;
					}
				});

				if (trigger === ComplianceRuleTriggerTypes.ChangeObject) {
					properties.unshift({
						AttributeId: classEntity.Id,
						AttributePath: classEntity.Id,
						Title: classEntity.DisplayName + '.*',
						Name: classEntity.DisplayName,
						ConditionType: ConditionTypes.Fragment,
					});
				}

				return properties;
			}
		});
	}

	function getProperties({ relatedClasses, trigger, typeIds, isBasedOnDD = false }) {
		var promises = [];
		if (!Array.isArray(relatedClasses) || relatedClasses.length === 0) {
			return $q.when([]);
		}
		relatedClasses.forEach(function (relatedClass) {
			promises.push(getClassProperties({ classObject: relatedClass, trigger: trigger, typeIds: typeIds, isBasedOnDD: isBasedOnDD }));
		});

		return $q.all(promises).then(function (classesProperties) {
			return Array.prototype.concat.apply([], classesProperties);
		});
	}

	function getDataTypeName(property) {
		if (property.IsPickup === true) {
			return 'EnumType';
		}

		switch (property.Datatype) {
			case DataTypes.BoolType:
				return 'BoolType';
			case DataTypes.DateType:
				return 'DateType';
			case DataTypes.ExpressionGuidType:
				return 'Expression';
			default:
				return 'String';
		}
	}

	function getConditionType(property) {
		if (property.IsPickup === true) {
			return ConditionTypes.EnumerationReference;
		}

		return helper.getConditionTypeByDataType(property.Datatype);
	}

	function getAllStateGroups() {
		if (self.allStateGroups) {
			return $q.when(self.allStateGroups);
		}
		return entityService.getEnumeration('SPSCommonPickupStateGroup').then(function (enumeration) {
			self.allStateGroups = {
				mapper: {},
				enum: [],
			};
			self.allStateGroups.enum = enumeration.Values.map(function (stateGroup) {
				self.allStateGroups.mapper[stateGroup.Value] = stateGroup.DisplayString;
				return {
					value: stateGroup.Value,
					title: stateGroup.DisplayString,
				};
			});

			return self.allStateGroups;
		});
	}

	function getStateGroups(className, typeIds) {
		return schemaService.getClassInfo(className).then(function (classObj) {
			var entityTypes = (classObj.UsedInTypes || []).filter(function (type) {
				return typeIds.indexOf(type.Id) > -1;
			});

			return getAllStateGroups().then(function (allStateGroups) {
				if (Array.isArray(entityTypes) && entityTypes.length > 0) {
					var stateGroups = entityTypes
						.filter(function (type) {
							return type.StateGroup;
						})
						.map(function (type) {
							return type.StateGroup;
						});

					stateGroups = _.uniq(stateGroups);
					if (stateGroups.length) {
						return stateGroups.map(function (stateGroup) {
							return {
								value: stateGroup,
								title: allStateGroups.mapper[stateGroup],
							};
						});
					}
				}

				return allStateGroups.enum;
			});
		});
	}
}
